import React, { useState } from 'react'

import EditNicknameModal from '../components/EditNicknameModal'
import EditSurveyFormModal from '../components/EditSurveyFormModal'
import MyAccountSetting from '../components/myAccountSettingLayout'
import { useBookcafeData } from '../module/myPage/hook'
import { useNativeInteractor } from '../module/nativeInteractor/context'
import { useSurveySteps } from '../module/survey/hook'
import { type SurveyStep } from '../module/survey/types'
import { type V2UserGroup } from '../module/survey/v2SurveyPayload'

const userGroupLabels: Record<V2UserGroup, string> = {
  university: '대학생',
  repeat_applicant: 'N수생/반수생',
  general: '일반인',
  high_school: '고등학생',
  middle_school: '중학생',
  elementary: '초등학생',
}

function getLearningTargetText(user: ReturnType<typeof useBookcafeData>['user']) {
  const keywordNames = user?.examKeywords?.map((keyword) => keyword.name) ?? []
  const customNames = user?.examCustomNames ?? []
  const learningTargets = [...keywordNames, ...customNames]

  return learningTargets.length === 0 ? null : learningTargets.join(',')
}

export default function MyBookcafeAccount() {
  const { user } = useBookcafeData()
  const { interactor } = useNativeInteractor()
  const { setSkipLastStep } = useSurveySteps()
  const [editStep, setEditStep] = useState<SurveyStep>('userGroup')
  const [openEditSurveyModal, setOpenEditSurveyModal] = useState<boolean>(false)
  const [openEditNicknameModal, setOpenEditNicknameModal] = useState<boolean>(false)

  const handleLogout = () => {
    console.log('logout')
    interactor.serviceLogout()
  }
  const learningTargetText = getLearningTargetText(user)

  return (
    <MyAccountSetting>
      <MyAccountSetting.Header />
      <MyAccountSetting.Contents title='계정 정보'>
        <MyAccountSetting.ContentsRow title='이메일'>
          <span className='text-sub-font'>{user?.email}</span>
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='닉네임'
          // visible={user?.nickName !== user?.email}
          editable
          onClickEdit={() => {
            setOpenEditNicknameModal(true)
          }}
        >
          {user?.nickName ?? ''}
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='그룹'
          visible={user?.userGroup !== undefined && user?.userGroup !== null}
          editable
          onClickEdit={() => {
            setEditStep('userGroup')
            setSkipLastStep(false)
            setOpenEditSurveyModal(true)
          }}
        >
          {user?.userGroup ? userGroupLabels[user.userGroup] : ''}
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='준비 시험'
          visible={user?.userGroup !== undefined && user?.userGroup !== null && !learningTargetText}
          editable
          onClickEdit={() => {
            setEditStep('examinations')
            setSkipLastStep(user?.userGroup !== 'university')
            setOpenEditSurveyModal(true)
          }}
        >
          준비중인 시험 없음
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow
          title='준비 시험'
          visible={learningTargetText !== null}
          editable
          onClickEdit={() => {
            setEditStep('examinations')
            setSkipLastStep(user?.userGroup !== 'university')
            setOpenEditSurveyModal(true)
          }}
        >
          <span className='line-clamp-2'>{learningTargetText}</span>
        </MyAccountSetting.ContentsRow>
        <MyAccountSetting.ContentsRow title='로그아웃' onClickTitle={handleLogout} />
        <MyAccountSetting.Extensions>
          <EditNicknameModal
            open={openEditNicknameModal}
            onClose={() => {
              setOpenEditNicknameModal(false)
            }}
          />
          <EditSurveyFormModal
            open={openEditSurveyModal}
            editStep={editStep}
            onCancel={() => {
              setOpenEditSurveyModal(false)
            }}
          />
        </MyAccountSetting.Extensions>
      </MyAccountSetting.Contents>
    </MyAccountSetting>
  )
}
